import { Injectable } from '@angular/core';

import { HttpClientService } from '../shared/service/http-client.service';

@Injectable()
export class StatsService {
  constructor(private http: HttpClientService) {}

  getPhotoStatsByTeam(teamId) {
    return this.http.get(`v1/teams/${teamId}/statistics?type=photos`);
  }

  getFormStatsByTeam(teamId) {
    return this.http.get(`v1/teams/${teamId}/statistics?type=forms`);
  }

  getPhotoStatsByProject(projectId) {
    return this.http.get(`v1/projects/${projectId}/statistics?type=photos`);
  }

  getFormStatsByProject(projectId) {
    return this.http.get(`v1/projects/${projectId}/statistics?type=forms`);
  }

  getFormStatsByCompany(companyId) {
    return this.http.get(`v1/companies/${companyId}/statistics?type=forms`);
  }

  getPhotoStatsByCompany(companyId) {
    return this.http.get(`v1/companies/${companyId}/statistics?type=photos`);
  }
}
